export const locale = {
    DB:{
        BANNER:'banner',
        ACTIVITY:'activity',
        CATEGORY:'category',
        CONTACT:'contact',
        FACULTY:'faculty',
        NEWS:'news'
    },
    NODATA: '目前暫無資料',
    NOPAGE: "此頁不存在",
    CATEGORY:{
        TITLE:'類別',
        ALL:'全 部'
    },
    HEADER:{
        ABOUT:'關於我們',
        MISSION:'中心宗旨',
        OURMEMBERS:'中心成員',
        NEWSCENTER:'中心熱訊',
        LATESTNEWS:'最新消息',
        MEDIA:'媒體報導',
        COLLABORATION:'產學合作',
        OBSERVATION:'世界觀察',
        WORLDNEWS:'全球新訊',
        VIEWS:'社會觀點',
        PROJECTS:'學術研究',
        ACTIVITIES:'活動剪影',
        CONTACTUS:'聯絡我們'
    },
    INDEX:{
        ABOUT:{
            TITLE:'企業重整 消費者破產',
            DESC:'中央大學企業再生與消費者破產研究中心成立宗旨為致力於對我國「企業重整」與「消費者破產」兩大領域的現代化發展而努力，期許我國未來法制以及相關建設和世界先進國家比肩，為我國廣大企業團體以及消費者族群在社會經濟高度發展過程中提供良好的再建重生契機。'
        },
        CENTERNEWS:'中心熱訊',
        ACTIVITYPHOTOS:'活動剪影',
        PRIVACY:{
            DESC:"為提供您最佳個人化且即時的服務，本網站透過使用 'Cookies' 記錄與存取您的瀏覽使用訊息。當您使用本網站，即表示您同意Cookies技術支援，關於更多 Cookies 以及相關政策更新資訊請閱讀我們的隱私權政策聲明。",
            BUTTON:'同意並關閉 <span>▶</span>'
        }
    },
    FOOTER:{
        NAME:'中央大學企業再生與消費者破產研究中心',
        ADDRESS:{
            TITLE:'地址',
            CONTENT:'(32001) 桃園市中壢區中大路300 號 – 志希館 8 樓'
        },
        PRIVACY:'隱私權政策',
        CONTACTUS:'聯絡我們'
    },
    MISSION:{
        TITLE:'中心宗旨',
        CONTENT:'企業再生與消費者破產研究中心成立宗旨為致力於對我國「<span>企業重整/再生</span>」與「<span>消費者破產</span>」兩大領域的現代化發展而努力，期許我國未來法制以及相關建設和世界先進國家比肩，為我國廣大企業團體以及消費者族群在社會經濟高度發展過程中提供良好的再建重生契機。',
        CRTITLE:'企業重整/再生',
        CRCONTENT1:'在「企業重整」(Corporate Reorganization)方面，公司重整制度係我國目前企業進行債務清理的最主要再生手段，對我國資本主義商業社會運作影響深遠。而我國公司重整制度自1966年公司法修正採用後，實施至今已逾五十年，公司法實務上重整制度運作不甚蓬勃，我國現行公司重整成功案例相對較少，廣大企業需要更多積極重生的機會，故公司法公司重整、破產法和解程序以及債務清理法草案和解章與重整章，均將是本中心研究關注對象。',
        CRCONTENT2:'在「企業再生」(Corporate Restructuring)方面，與此同時，「企業再生」作為世界各主要國家商業運作熱門議題，其內容豐富多元，凡屬企業併購、企業轉型、企業升級均屬可進一步探討領域。其中，「企業併購」(M&A)為世界及我國企業組織再造之主流手段，其多樣化的型態和企業重整之關聯性值得深入關注，本研究中心將持續推動現代企業重整與企業併購各自獨特卻又關係密切的相關研究。',
        CRCONTENT3:'在此之中，「私募股權」(Private Equity)與「另類投資」(Alternative Investment)已經在當今世界資本市場上形成龐大的重要力量，其對現代企業重整、企業併購、企業組織再造以及企業再生的關鍵影響，本中心將持續關注研究。因此，本研究中心將在我國經濟發展快速變遷的時代背景下，檢視現行公司重整制度的設計與運作，關注世界主要國家的最新發展趨勢，<span>提出並研究新世代企業重整/再生以及企業併購制度的各種可能設計與建議，以做為台灣經濟社會發展下一階段的配套拼圖。</span>',
        CBTITLE:'消費者破產',
        CBCONTENT1:'在「消費者破產」(Consumer Bankruptcy)方面，鑒於全球經濟發展的快速變遷，青年族群就業困難，中壯年族群失業人口增加，年長族群年金給付不足/刪減等議題逐步發生，全球社會各世代皆陷入嚴重的債務可能困境，消費者破產已經是世界各國刻不容緩的重大議題，我國亦不例外。故在台灣貧富差距不斷擴大背景下，台灣整體破產體制需有更多面向的思維加以關注。',
        CBCONTENT2:'另外，在台灣消費者破產體制快速發展之餘，我國廣大消費者對現代破產之認知也需進一步加強，以更好的維護自身權益，故本中心將持續推廣全國消費者對現代破產制度的進一步認知。',
        CBCONTENT3:'因此，本研究中心希望就消費者破產議題方面提供社會上各層面之觀察與建議，推動我國消費者破產體制與世界的進一步對話，<span>並致力為我國消費者債務清理條例的持續更新以及司法院債務清理法草案的通過公布而努力，以迎接我國全新的債務清理法制，為我國債務者提供良善的制度保護。',
        FBTITLE:'未來展望',
        FBCONTENT1:'最後，本研究中心將透過管理學院之法律學門與經濟學門兩大專業學科以及管理學院其他學門（例如：財金學門）一起努力，對我國「企業重整/再生」與「消費者破產」兩大領域持續研究，為我國廣大企業與消費者提供良好的交流平台：',
        FBCONTENT2:'一方面提出具體建議予國家公部門做為參考，另ㄧ方面亦可為我國廣大企業和消費者提供適當的再生契機，<span>讓我國現代化的破產/重整制度能夠被社會上廣大企業和民眾所認識並加以妥善運用，進而在世上展現我國債務清理機制未來的全新風貌。</span>',
    },
    CONTACT:{
        EMAIL:'信箱',
        ADDRESS:{
            TITLE:'地址',
            CONTENT:'<span>( 32001 )</span>桃園市中壢區中大路300 號 – 志希館 8 樓'
        },
        DESC:'如有本中心之相關事宜，歡迎您填寫聯絡表單，<span>或將相關資訊寄至E-mail，我們將盡快與您聯繫！</span>',
        REQUIRED:'為必填欄位',
        NAME:'姓名',
        NAMEMSG:'請輸入您的姓名',
        COMPANY:'公司名稱',
        COMPANYMSG:'請輸入您的公司名稱',
        PHONE:'電話',
        PHONEMSG:'請輸入您的電話',
        EMAILFIELD:'E-mail',
        EMAILFIELDMSG:'請輸入您的E-mail',
        SUBJECT:'主旨',
        SUBJECTMSG:'請輸入您的主旨',
        CONTENT:'內容',
        CONTENTMSG:'請輸入您的內容',
        CAPTCHA:'驗證碼',
        CAPTCHAMSG:'請輸入驗證碼',
        CAPTCHAERROR:'驗證碼輸入錯誤',
        SUBMIT:'確認送出',
        PHONEERROR:'請輸入純數字',
        EMAILERROR:'請輸入正確E-mail格式'
    },
    PRIVACY:{
        TITLE:'隱私權政策聲明',
        DESC:'本站和應用程式（以下簡稱「本站」）在您的電腦或裝置上使用Cookies或類似的追蹤工具，以便我們（例如）為您提供個人化的服務及／或於您瀏覽不同網頁及／或互聯網期間進行身份識別。',
        CLAUSE_1_TITLE:'▏Cookies是什麼？',
        CLAUSE_1_CONTENT:'Cookies是由網站或應用程式放置在您裝置上的小型文字檔，以便記住您的相關資訊，例如：語言喜好設定或登入資訊。該等Cookies由我們設置，稱為「第一方」Cookies。我們另使用「第三方」Cookies進行廣告宣傳及市場推廣。',
        CLAUSE_2_TITLE:'▏我們設置哪些類型的Cookies？',
        CLAUSE_2_CONTENT_1:'絕對必要性Cookies：該等Cookies對於啟用本站的頁面導覽和存取安全區域（客戶個人資料）等基本功能至關重要。若沒有該等Cookies，本站無法正常運行。',
        CLAUSE_2_CONTENT_2:'性能和功能性Cookies／性能Cookies：該等Cookies用於記住改變本站行為和觀感的資訊，例如：您的喜好語言或您所在的區域。',
        CLAUSE_2_CONTENT_3:'分析性Cookies／統計學Cookies：該等Cookies用於收集資訊，以了解您與本站的交互方式。我們可能會在本站使用由我們開發或由第三方提供商提供的網站分析服務和工具（例如，由Google, Inc.提供的Google Analytics），以幫助我們監察和分析網站的訪客流量、行為和統計資料。為此，Google Analytics主要使用存儲非個人身份識別資訊的第一方Cookies，向我們報告使用者在網站的交互情況。如需了解有關Google Analytics的詳情，請瀏覽www.google.com/analytics/。如要了解Google Analytics如何收集和處理資料，請前往下述網站www.google.com/policies/privacy/partners/，查看「Google 如何運用來自採用 Google 服務的網站和應用程式的資訊」。',
        CLAUSE_2_CONTENT_4:'廣告Cookies／市場推廣Cookies：該等Cookies有助於提供與您的興趣更相關的廣告。該等廣告通常由經我們許可的廣告網絡投放。',
        CLAUSE_2_CONTENT_5:'社交網絡Cookies：允許訪客透過第三方社交網站分享我們的網頁和內容。',
        CLAUSE_3_TITLE:'▏該等Cookies會在您的瀏覽器中留存多久？',
        CLAUSE_3_CONTENT:'有兩類Cookies：工作階段Cookies和持續Cookies。工作階段Cookies僅在您瀏覽本站期間保留，並在您關閉瀏覽器或應用程式後刪除。持續Cookies將儲存在您的瀏覽器中，以備您下次瀏覽本站時使用。',
        CLAUSE_4_TITLE:'▏管理「Cookies」',
        CLAUSE_4_CONTENT:'本站預設設置為接受Cookies。您可透過更改您之網頁或行動瀏覽器上的設置，選擇退出或刪除歷史Cookies；但是，如果您這樣做，本站上的若干功能可能無法正常運行。'
    },
    OURMEMBER:{
        EDUCATION:'學歷',
        EXPERTISE:'專長',
        PHONE:'電話'
    }
}


// WEBPACK FOOTER //
// ./src/lang/zh.js